// @flow
import { css } from "styled-components"

export const fontWeight = css`
  font-weight: ${(props) => props.theme.fontWeights.normal};

  ${p =>
    p.book &&
    css`
      font-weight: ${(props) => props.theme.fontWeights.book};
    `}
  ${p =>
    p.medium &&
    css`
      font-weight: ${(props) => props.theme.fontWeights.medium};
    `}
  ${p =>
    p.bold &&
    css`
      font-weight: ${(props) => props.theme.fontWeights.bold};
    `}
  ${p =>
    p.ultra &&
    css`
      font-weight: ${(props) => props.theme.fontWeights.ultra};
    `}
`

export const color = css`
  ${p => p.black &&
  css`
      color: ${(props) => props.theme.color.primaryText};
    `}
  ${p => p.white &&
  css`
      color: ${(props) => props.theme.color.white};
    `}
  ${p => p.primary &&
  css`
      color: ${(props) => props.theme.color.primaryAccent};
    `}
`;

export const uppercase = css`
  ${p =>
    p.uppercase &&
    css`
      text-transform: uppercase;
    `}
`

export const display = css`
  ${p =>
    p.inline &&
    css`
      display: inline-block;
    `}
`

export const align = css`
  ${p =>
    p.center &&
    css`
      text-align: center;
    `}
`



// WEBPACK FOOTER //
// ./src/componentsStyled/Typography/enhancers.js